<div [id]="id" class="madero-style alert alert-{{type}} {{cssClass}}" role="alert" aria-live="polite">
  @if (title) {
    <div>
      <i aria-hidden="true" class="fa icon-left {{iconClass[type]}}"></i>
      <span [ngClass]="{ 'title-bold': boldTitle }">{{title}}</span>
    </div>
  }
  @if (message) {
    <p class="my-2">{{message}}</p>
  }
  <div class="content-wrapper">
    <ng-content></ng-content>
  </div>
</div>